<template>
	<div class="chat-wrapper">
		<div v-if="chatArr">
			<div class="header-bar">
				<span class="title-text">{{chatArr.headerTitle||"🍅 星际种植小管家"}}</span>
			</div>

			<div class="chat-container" ref="chatContent" @scroll="handleScroll">
				<div class="top-icons">
					<div class="icon moon-icon">
						<img v-if="chatArr.topIcon1&&chatArr.topIcon1.includes('http')"
							:src="getImgSrc(chatArr.topIcon1)" />
						<span v-else>{{chatArr.topIcon1}}</span>
					</div>
					<div class="icon tomato-icon">
						<img v-if="chatArr.topIcon2&&chatArr.topIcon2.includes('http')"
							:src="getImgSrc(chatArr.topIcon2)" />
						<span v-else>{{chatArr.topIcon2}}</span>
					</div>
				</div>
				<div v-if="hasMore&&loadingHistory" style="text-align:center;padding:12px 0;"><img
						src="@/ico/loading.svg" style="width: 30px;" />加载中...</div>
				<div v-for="(msg, idx) in chatList" :key="idx" class="msg-item" :class="getMsgClass(msg)">
					<div class="avatar">
						<div v-if="msg.role==='student'">
							<img v-if="chatArr.avatarStu&&chatArr.avatarStu.includes('http')"
								:src="chatArr.avatarStu" />
							<span v-else>{{chatArr.avatarStu||'1🎓'}}</span>
						</div>
						<div v-else-if="msg.role==='ai'">
							<img v-if="chatArr.avatarAi&&chatArr.avatarAi.includes('http')" :src="chatArr.avatarAi" />
							<span v-else>{{chatArr.avatarAi||'1🍅'}}</span>

						</div>
						<div v-else>

							<img v-if="chatArr.avatarTea&&chatArr.avatarTea.includes('http')"
								:src="chatArr.avatarTea" />
							<span v-else>{{chatArr.avatarTea||'1📝'}}</span>
						</div>

					</div>
					<div class="msg-content" :style="{ 
					       backgroundColor: msg.role === 'student' 
					         ? (chatArr.bubbleSelf || '#c5e1a5') 
					         : (chatArr.bubbleOther || '#ffffff') 
					     }">
						<div v-if="msg.time" class="msg-time">{{ formatTime(msg.time) }}</div>

						<div v-if="msg.messageList.length>0" v-for="(message, index) in msg.messageList"
							:key="`follow-message-${index}`">
							<div v-if="!msg.messageList[0].content && msg.role=='ai'" class="el-icon-loading"></div>
							<div v-if="message.fileType=='text'">
								<div v-if="message.content"
									v-for="(item, index) in message.content&&message.content.split('\n')"
									:key="`follow-msg-${index}`">
									<div v-html="forImg(item)"></div>
								</div>
							</div>
							<div v-if="message.fileType=='img'" class="img-box">
								<!-- imgUrl为空 = 加载中，显示loading占位 -->
								<!-- <img :src="require('@/ico/loading.svg')" style="width:28px;" alt=""> -->

								<div v-if="!message.imgUrl" class="img-loading">
									<img :src="require('@/ico/loading.svg')" style="width:28px;" alt="">
								</div>

								<img v-else :src="message.imgUrl" alt="图片" class="chat-img" />
							</div>
						</div>

					</div>
				</div>

				<div v-for="(item, index) in followUpList" :key="`follow-up-${index}`">
					<div class="follow-up-item" @click="userType == 2 ? null : sendMsgT(item)"
						:class="{ disabled: userType == 2 }">
						{{ item }}
					</div>
				</div>
			</div>
			<div class="input-wrapper">
				<!-- 图片预览上浮层：绝对定位，在输入框顶部外侧，不遮挡输入 -->
				<div v-if="fileList.length > 0" class="upload-preview-box">
					<div v-for="(fileItem, idx) in fileList" :key="idx" class="preview-item">
						<img :src="fileItem.localUrl" alt="预览图" class="preview-img" />
						<span class="close-del" @click="delUploadImg(idx)">×</span>
					</div>
				</div>

				<!-- 输入栏本体 -->
				<div class="input-bar" v-if="chatArr.chatFily.length>0">
					<!-- 控制是否启用图片/文本对话/文件的逻辑 -->
					<label class="upload-img-btn" v-if="userType == 3&&isImg">
						<img src="@/ico/uploadImg.svg" style="width: 28px;" />
						<input type="file" accept="image/jpeg,image/png,image/gif,image/webp" style="display:none"
							@change="handleUploadImg" />
					</label>
						<input v-model="inputMsg" @keyup.enter="sendMsg" class="chat-input"
							:placeholder="userType == 3 ? '输入你的问题...' : '请输入干预的信息...'"
							:disabled="(userType==2&&!isSave)||studentId==''" v-if="(userType==2)||(userType==3&&isText)"/>
						<button class="send-btn" @click="sendMsg" v-if="(userType==2)||(userType==3&&isText)"
							:disabled="isLocked || (!inputMsg.trim()&&fileList.length==0)">
							发送
						</button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		checkSensitiveWord,
		adminMonitorWork
	} from '@/views/student/classComponents/studentClass.js'
	import {
		fullUploadImage
	} from '@/js/img.js'
	import {
		getModelWithoutKey
	} from "@/js/calssComponets.js"
	export default {
		name: "Chat",
		props: {
			courseClassId: {
				type: String,
				default: "0"
			},
			studentId: {
				type: String,
				default: ""
			},
			isLocked: Boolean,
		},

		data() {
			return {
				chatList: [],
				inputMsg: '',
				isAIApiProcessing: false,
				hasSavedConversationId: false,
				schoolId: localStorage.getItem('orgId'),
				userType: localStorage.getItem('userType'),
				followUpList: [],
				studentIdWatcherTimer: null,
				isOne: false,
				isSave: localStorage.getItem('isSave') || false,
				chatArr: {

				},
				lastTime: null,
				lastCreateTime: null,
				pageSize: 10,
				hasMore: false, //判断是否有可以翻页的数据
				// 记录上次滚动位置
				lastScrollTop: 0,
				// 防抖锁，避免连续滚动多次调用接口
				loadingHistory: false,
				fileList: [], // 上传图片列表，每个项包含本地预览地址+文件对象
				login: null,
				scrollH: 0,
				isUpdataLogin: false,
				aiContentText: null,
				isImg:false,//没有图片功能
				isText:false,
				isFile:false,
			};
		},
		watch: {
			// 监听学生切换 → 重置聊天
			studentId(newVal, oldVal) {
				if (newVal && newVal !== oldVal) {
					this.lastTime = null
					this.chatList = []
					this.hasMore = false
					this.lastCreateTime = null
					this.resetChatAndReload()
				}
			},
			chatArr: {
				deep: true,
				handler() {
					this.$nextTick(() => {
						this.$forceUpdate()
					})
				}
			}
		},
		created() {
			this.foParms()
			if (localStorage.getItem('userType') == 3) {
				adminMonitorWork()
			}
			this.$nextTick(() => {
				this.$forceUpdate() // 强制组件重绘
				if (this.studentId != '') {
					this.lastTime = null
					this.loadHistoryChat();
				}
			})
		},
		beforeDestroy() {
			this._isDestroyed = true;
		},
		methods: {
			// 渲染MathJax公式
			async renderMathJax() {
			  if (!window.MathJax) return;
			
			  setTimeout(async () => {
			    await this.$nextTick();
			    try {
			      await MathJax.typesetPromise();
			    } catch (err) {
			      console.error('MathJax渲染错误:', err);
			    }
			    this.scrollBottom();
			  }, 1000);
			},
			handleUploadImg(e) {
				const fileListRaw = e.target.files;
				if (!fileListRaw.length) return;
				const rawFile = fileListRaw[0];
				if (!rawFile.type || !rawFile.type.startsWith('image/')) {
					this.$message.warning('请上传图片文件');
					e.target.value = '';
					return;
				}
				const localPreviewUrl = URL.createObjectURL(rawFile);
				this.fileList.push({
					file: rawFile, // 核心：原始File二进制文件，上传接口用
					localUrl: localPreviewUrl, // 本地预览地址
					fileName: rawFile.name,
					size: rawFile.size,
					type: rawFile.type
				});
				e.target.value = '';
			},
			// 删除已上传图片
			delUploadImg(index) {
				const delItem = this.fileList[index];
				URL.revokeObjectURL(delItem.localUrl);
				this.fileList.splice(index, 1);
			},
			handleScroll() {
				if (this.isUpdataLogin) return
				const dom = this.$refs.chatContent;
				const clientH = dom.clientHeight
				// 内容总高度
				const scrollH = dom.scrollHeight
				if (scrollH <= clientH && this.chatList.length <= this.pageSize) {
					this.loadHistoryMsg(1);
				}
				const currentScrollTop = dom.scrollTop;
				// 向上滚动：当前滚动值 < 上次滚动值
				const isScrollUp = currentScrollTop < this.lastScrollTop;
				// 新增：滚动到距离顶部50px以内才触发加载
				if (isScrollUp && currentScrollTop < 50 && !this.loadingHistory) {
					this.scrollH = dom.scrollHeight
					this.isUpdataLogin = true
					this.loadHistoryMsg();
					setTimeout(() => {
						this.isUpdataLogin = false

					}, 500)

				}
				// 更新上次滚动位置
				this.lastScrollTop = currentScrollTop;
			},
			// 2026-07-28 聊天分页：兼容 md 分校集合分页字段，避免上拉旧 10 条重复渲染。
			getPageData(data) {
				if (!data) return {}
				if (data.data && typeof data.data === 'object') return data.data
				return data
			},
			getPageRecords(data) {
				if (!data) return []
				if (Array.isArray(data)) return data
				const records = data.records || data.content || data.list || data.rows
				return Array.isArray(records) ? records : []
			},
			normalizeMessageList(messageList) {
				if (Array.isArray(messageList)) return messageList
				if (typeof messageList === 'string') {
					try {
						const parsed = JSON.parse(messageList)
						return Array.isArray(parsed) ? parsed : []
					} catch (e) {
						return []
					}
				}
				return []
			},
			getChatUniqueKey(item) {
				if (!item) return ''
				if (item.id || item.chatId || item.messageId || item.recordId) {
					return item.id || item.chatId || item.messageId || item.recordId
				}
				const firstMsg = item.messageList && item.messageList[0] ? item.messageList[0] : {}
				return `${item.role || ''}_${item.time || ''}_${firstMsg.fileType || ''}_${firstMsg.content || ''}`
			},
			normalizeChatRecords(pageData) {
				return this.getPageRecords(pageData).map((i) => {
					const item = {
						id: i.id || i.chatId || i.messageId || i.recordId || '',
						role: i.role,
						messageList: this.normalizeMessageList(i.messageList),
						time: i.createTime || i.time
					}
					item.localKey = this.getChatUniqueKey(item)
					return item
				}).sort((a, b) => a.time - b.time);
			},
			prepareMessageImages(list, shouldScroll) {
				list?.forEach(item => {
					if (!item.messageList) return;
					item.messageList.forEach(msg => {
						if (msg.fileType === 'img' && msg.content && !msg.imgUrl) {
							msg.imgUrl = '';
							this.$oss.getDownloadUrl(msg.content)
								.then(url => {
									msg.imgUrl = url;
									if (shouldScroll) {
										setTimeout(() => {
											this.scrollBottom();
										}, 200)
									}
								})
								.catch(() => {
									msg.imgUrl = '';
								});
						}
					});
				});
			},
			mergeChatList(frontList, backList) {
				const used = new Set()
				const merged = []
				const pushItem = (item) => {
					const key = this.getChatUniqueKey(item)
					if (key && used.has(key)) return
					if (key) used.add(key)
					merged.push(item)
				}
				frontList.forEach(pushItem)
				backList.forEach(pushItem)
				return merged
			},
			async loadHistoryMsg(type) {
				if (this.loadingHistory || !this.hasMore) {
					this.loadingHistory = false
					return
				}
				this.loadingHistory = true
				try {
					let res = {}
					let params = {
						schoolId: localStorage.getItem('orgId'),
						courseClassId: this.courseClassId,
						studentId: this.studentId,
						pageSize: this.pageSize,
						lastCreateTime: this.lastCreateTime
					};
					//学生不需要轮询，第一次拿所有，停止轮询
					if (this.userType == 3) {
						res = await this.API.get(this.API.school.getStudentChatPage, params);
					} else {
						res = await this.API.get(this.API.school.getTeacherChatPage, params);
					}
					const pageData = this.getPageData(res.data)
					this.hasMore = !!pageData.hasMore
					this.lastCreateTime = pageData.minCreateTime || this.lastCreateTime

					let list = this.normalizeChatRecords(pageData);
					this.prepareMessageImages(list, false)
					list?.forEach(item => {
						if (!item.messageList) return;
						item.messageList.forEach(msg => {
							if (msg.fileType === 'img' && msg.content && msg.imgUrl === undefined) {
								// 第一步：先赋值空字符串占位，模板立刻渲染，不会报错
								msg.imgUrl = '';
								// 第二步：异步请求OSS地址，拿到后覆盖
								this.$oss.getDownloadUrl(msg.content)
									.then(url => {
										msg.imgUrl = url; // 请求成功替换真实图片地址
									})
									.catch(() => {
										msg.imgUrl = ''; // 失败保持空，可换成兜底图地址
										// msg.imgUrl = '/static/default-img-fail.png';
									});
							}

						});
					});
					this.chatList = this.mergeChatList(list, this.chatList)
					if (type) {
						this.scrollBottom()
					} else {
						this.scrollBottom('up')
					}
				} catch (err) {
					console.error('加载历史消息失败', err);
				} finally {
					this.loadingHistory = false
				}

			},
			getImgSrc(src) {
				// 1. 空值兜底
				if (!src) return '';

				// 2. 纯 emoji：不是 http、不是 @/，直接当字符返回
				if (!src.startsWith('http') && !src.startsWith('@/')) {
					return src;
				}

				// 4. @/ 本地资源 → 用 require 处理
				if (src.startsWith('@/')) {
					try {
						return require(`~${src}`);
					} catch (e) {
						console.warn('本地图片找不到：', src);
						return '';
					}
				}

				return src;
			},
			async foParms() {
				try {
					let parmsString = localStorage.getItem('parms')
					let parms = JSON.parse(parmsString)
					this.chatArr = parms.chat
					if(this.chatArr?.chatFily?.length>0){
						this.isImg=this.chatArr.chatFily.find(v=>v=="img")?true:false
						this.isText=this.chatArr.chatFily.find(v=>v=="text")?true:false
						this.isFile=this.chatArr.chatFily.find(v=>v=="file")?true:false
						console.log(this.isImg,this.isText,this.isFile)
					}
					console.log('this.chatArr', this.chatArr)
				} catch (error) {

				}
			},
			resetChatAndReload() {
				// 1. 停止之前的轮询定时器
				if (this.studentIdWatcherTimer) {
					clearTimeout(this.studentIdWatcherTimer)
					this.studentIdWatcherTimer = null
				}
				this.scrollBottom()
				// 2. 清空聊天列表
				this.chatList = []
				this.followUpList = []
				this.isOne = false // 允许重新加载
				this.isAIApiProcessing = false
				this.hasSavedConversationId = false
				localStorage.removeItem('followUpList')

				// 3. 重新加载历史
				this.$nextTick(() => {
					this.loadHistoryChat()
				})
			},
			// 核心：判断消息左右
			getMsgClass(msg) {
				// 学生端：自己（student）靠右
				if (this.userType == 3) {
					return msg.role === 'student' ? 'right' : 'left';
				}
				// 老师端：自己（teacher）靠右
				else if (this.userType == 2) {
					return msg.role === 'teacher' ? 'right' : 'left';
				}
				return 'left';
			},

			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			sendMsgT(inputMsg) {
				this.inputMsg = inputMsg
				this.sendMsg()
			},
			formatTime(t) {
				if (!t) return ''
				const d = new Date(t)
				return d.toLocaleString()
			},
			scrollBottom(type) {
				this.$nextTick(() => {
					const el = this.$refs.chatContent
					if (!el) return
					// 强制让浏览器重绘，保证高度正确
					setTimeout(() => {
						el.scrollTop = 0
						if (type == "up") {
							el.scrollTop = el.scrollHeight - this.scrollH + 50
						} else {
							el.scrollTop = el.scrollHeight + 100
						}
						
					}, 60)
				})
			},
			toTeacherMsg(msg) {
				let newList = []
				newList[0] = msg
				newList?.forEach(item => {
					if (!item.content) return;
					item.content.forEach(msg => {
						if (msg.fileType === 'img' && msg.content && msg.imgUrl === undefined) {
							// 第一步：先赋值空字符串占位，模板立刻渲染，不会报错
							msg.imgUrl = '';
							// 第二步：异步请求OSS地址，拿到后覆盖
							this.$oss.getDownloadUrl(msg.content)
								.then(url => {
									msg.imgUrl = url; // 请求成功替换真实图片地址
									setTimeout(() => {
										this.scrollBottom();

									}, 200)
								})
								.catch(() => {
									msg.imgUrl = ''; // 失败保持空，可换成兜底图地址
									// msg.imgUrl = '/static/default-img-fail.png';
								});
						}
					});
				});
				this.chatList.push({
					role: msg.role,
					messageList: newList[0].content,
					time: msg.createTime
				})
				this.$nextTick(() => {
					setTimeout(() => {
						this.scrollBottom();
					}, 120);
				});
			},
			forImg(str) {
				if (str.indexOf("https://") > -1 && str.indexOf(".png") > -1 && str.indexOf("src=") == -1) {
					var str1 = str.split('https://')[0]
					var str2 = str.split('https://')[1]
					var str3 = str2.split('.png')[0]
					var str4 = str2.split('.png')[1]
					str = `${str1}</br><img src="https://${str3}.png" width="200px" />${str4}`
				}
				return str
			},
			// 加载历史
			async loadHistoryChat() {
				if (!this.studentId || !this.courseClassId) return;
				if (this.isOne) return;

				try {
					let res = [];
					let params = {
						schoolId: localStorage.getItem('orgId'),
						courseClassId: this.courseClassId,
						studentId: this.studentId,
						pageSize: this.pageSize,
						lastCreateTime: this.lastCreateTime
					};
					//学生不需要轮询，第一次拿所有，停止轮询
					if (this.userType == 3) {
						res = await this.API.get(this.API.school.getStudentChatPage, params);
						this.isOne = true
					}
					//老师需要轮询本地保存增加最后一次时间
					else {
						let newParams = {
							schoolId: localStorage.getItem('orgId'),
							courseClassId: this.courseClassId,
							studentId: this.studentId,
							pageSize: this.pageSize,
						}
						if (this.lastTime) {
							newParams.lastTime = this.lastTime
						}

						res = await this.API.get(this.API.school.getTeacherChatPage, newParams);
					}

					const pageData = this.getPageData(res.data)
					const pageRecords = this.getPageRecords(pageData)
					if (res.data?.code === 200 && pageRecords.length > 0) {
						this.hasMore = !!pageData.hasMore
						this.lastCreateTime = pageData.minCreateTime || this.lastCreateTime

						let list = this.normalizeChatRecords(pageData);
						this.prepareMessageImages(list, true)
						list?.forEach(item => {
							if (!item.messageList) return;
							item.messageList.forEach(msg => {
								if (msg.fileType === 'img' && msg.content && msg.imgUrl ===
									undefined) {
									// 第一步：先赋值空字符串占位，模板立刻渲染，不会报错
									msg.imgUrl = '';
									// 第二步：异步请求OSS地址，拿到后覆盖
									this.$oss.getDownloadUrl(msg.content)
										.then(url => {
											msg.imgUrl = url; // 请求成功替换真实图片地址
											setTimeout(() => {
												this.scrollBottom();

											}, 200)
										})
										.catch(() => {
											msg.imgUrl = ''; // 失败保持空，可换成兜底图地址
											// msg.imgUrl = '/static/default-img-fail.png';
										});
								}
							});
						});
						if (this.userType == 3) {
							this.chatList = list
						} else {
							if (list.length > 0) {
								this.chatList = this.mergeChatList(this.chatList, list)
							}

						}
						// 取最后一条的 followUpList
						let lastItem = pageRecords[0];

						if (this.userType == 2 && pageRecords.length > 0) {
							this.lastTime = pageRecords[0].createTime || null

						}
						if (lastItem) {
							if (typeof lastItem.followUpList === "string") {
								try {
									this.followUpList = JSON.parse(lastItem.followUpList);
									console.log('this.followUpList ', this.followUpList)
									localStorage.setItem('followUpList', lastItem.followUpList);
								} catch {
									this.followUpList = []
									localStorage.removeItem('followUpList')
								}
							}
						} else {
							this.followUpList = []
							localStorage.removeItem('followUpList')
						}
					} else {
						
						if (this.chatList.length > 0) return
						
						let content = `你好呀～我是🌕月球基地小管家！<br>
			欢迎来到月球番茄种植基地～🌱<br>
			我可以帮你设计实验、评价方案，还能带你探索月球种植的奥秘！`
						if (this.chatArr.aiContentText) {
							content = this.chatArr.aiContentText
						}
						this.chatList = [{
							role: 'ai',
							messageList: [{
								"content": content,
								"fileType": "text"
							}],
							time: Date.now()
						}];
					}

					this.$nextTick(() => {
						setTimeout(() => {
							this.scrollBottom();
						}, 120);
					});
					this.handleScroll()
				} catch (e) {
					if (this.chatList.length > 0) return
					
					let content = `你好呀～我是🌕月球基地小管家！<br>
					欢迎来到月球番茄种植基地～🌱<br>
					我可以帮你设计实验、评价方案，还能带你探索月球种植的奥秘！`
					if (this.chatArr.aiContentText) {
						content = this.chatArr.aiContentText
					}
					this.chatList = [{
						role: 'ai',
						messageList: [{
							"content": content,
							"fileType": "text"
						}],
						time: Date.now()
					}];
					this.$nextTick(() => {
						setTimeout(() => {
							this.scrollBottom();
						}, 120);
					});
				} finally {
					this.studentIdWatcherTimer = setTimeout(() => {
						if (this._isDestroyed) return;
						if (this.studentId && this.courseClassId) {
							this.loadHistoryChat();
						}
					}, 3000);
					this.renderMathJax()
				}
			},
			async handleSend() {
				const content = this.inputMsg.trim();
				if (!content) return this.$message.warning("请输入干预消息内容！");
				if (!this.studentId) return this.$message.warning("请先选择要干预的学生！");
				let messageList = []
				messageList[0] = {
					content: content,
					fileType: "text"
				}
				try {
					const {
						data
					} = await this.API.post(this.API.school.postChat, {
						schoolId: Number(this.schoolId),
						courseClassId: Number(this.courseClassId),
						studentId: Number(this.studentId),
						teacherId: localStorage.getItem('userId'),
						messageList: messageList,
						role: "teacher",
						source: 1
					});
					if (data.code === 200) {
						this.inputMsg = "";
						this.$message.success("干预消息发送成功！");

					} else {
						this.$message.error("发送失败：" + (data.msg || "服务器错误"));
					}
					this.$nextTick(() => {
						setTimeout(() => {
							this.scrollBottom()
						}, 100)
					})
				} catch (e) {
					console.error("发送教师干预消息失败：", e);
					this.$message.error("发送失败，请重试！");
				}
			},

			// 发送消息
			async sendMsg() {
				const ossImgUrls = [];
				let messageList = []
				if (this.fileList.length > 0) {
					this.loginOpen('文件上传中...')
				}
				try {
					for (const item of this.fileList) {
						// item.file 就是原生File，传给oss上传方法
						const onlineUrl = await fullUploadImage(item.file, this.courseClassId, this.studentId, 0,
							"student", "对话文件");

						var type = "text"
						if (item.type && item.type.startsWith("image/")) {
							type = "img"
						}

						ossImgUrls.push({
							"content": onlineUrl.url,
							"fileType": type,
							"imgUrl": item.localUrl
						});
					}
					if (this.userType == 2) {
						await this.handleSend()
					} else {
						this.followUpList = []
						localStorage.removeItem('followUpList')
						const content = (this.inputMsg || '').trim()
						if ((!content && this.fileList.length == 0) || this.isLocked || this.isAIApiProcessing) return
						let check = {
							isSensitive: false
						}
						if (content) {
							messageList[0] = {
								fileType: "text",
								content: content
							}
							check = checkSensitiveWord(content, this.courseClassId, localStorage.getItem(
								'studentInfo'))
						}
						if (check.isSensitive) {
							this.$message.error(`包含敏感词：${check.word}`)
							return
						}
						if (ossImgUrls.length > 0) {
							messageList = [...messageList, ...ossImgUrls]
						}

						this.chatList.push({
							role: 'student',
							messageList,
							time: Date.now()
						})
						this.noLogin()
						this.inputMsg = ''
						this.fileList = []


						let keyRes = await getModelWithoutKey(this.chatArr.keyId)

						// 1. 生成【一次性旋转好】的文件
						if (!keyRes.isQuest) return this.$message('密钥已过期')
						let providerCode = keyRes.providerCode
						let res = await this.forPostStudentChat(messageList, 'student')
						const ai = await this.callAIApi(
							messageList, // 给AI用上传后的地址
							providerCode
						);
						this.renderMathJax()
						if (ai) {
							this.followUpList = ai.followUpList
							localStorage.setItem('followUpList', JSON.stringify(ai.followUpList))
						}
						let aiMessageList = []
						aiMessageList[0] = {
							fileType: "text",
							content: ai.fullContent
						}
						if (ai) await this.forPostStudentChat(aiMessageList, 'ai', ai.inputTokens,
							ai.outputTokens, ai.aiContent, JSON.stringify(ai.followUpList), ai.aiid)
					}
				} catch (err) {
					this.noLogin()
				}


			},
			async callAIApi(messageList, platform) {
				this.isAIApiProcessing = true;
				let publicPath = '';
				var isVue = this.API.isVue;
				const pathParts = window.location.pathname.split('/');

				if (isVue == 1) {
					if (pathParts[1] == 'test') publicPath = '/test';
				}
				if (isVue == 2) publicPath = '/api';
				if (isVue == 4) publicPath = '/v1/api';
				if (isVue == 5) publicPath = '/v1';

				const url = publicPath + "/sys/school/chat/stream/chat";

				for (let i = 0; i < messageList.length; i++) {
					if (messageList[i].fileType != 'text') {
						const contentUrl = await this.$oss.getDownloadUrl(messageList[i].content)
						messageList[i].content = contentUrl
					}
				}
				// ========== 多平台解析规则 ==========
				const parseRules = {
					// 自有默认平台
					local: (data) => {
						const res = {
							content: "",
							follow: [],
							usage: {
								inputTokens: 0,
								outputTokens: 0,
								totalTokens: 0
							},
							conversationId: ""
						};
						if (data.type === "answer" && data.content) {
							res.content = data.content;
						}
						if (data.type === "follow_up" && data.content) {
							res.follow.push(data.content);
						}
						if (data.usage) {
							res.usage.inputTokens = data.usage.input_count || 0;
							res.usage.outputTokens = data.usage.output_count || 0;
							res.usage.totalTokens = data.usage.token_count || 0;
						}
						if (data.conversation_id) {
							res.conversationId = data.conversation_id;
						}
						return res;
					},

					// 扣子工作流 coze_flow未处理
					coze_flow: (data) => {
						const res = {
							content: "",
							follow: [],
							usage: {
								inputTokens: 0,
								outputTokens: 0,
								totalTokens: 0
							},
							conversationId: "",
							aiid: '',
						};
						console.log('data111:', data)
						//非流式
						if (data.content) {
							res.content += data.content

						}
						if (data.data) {
							res.usage.inputTokens = data.usage.input_count || 0;
							res.usage.outputTokens = data.usage.output_count || 0;
							res.usage.totalTokens = data.usage.token_count || 0;
							let cont = data
							try {
								if (typeof data === 'string') {
									cont = JSON.parse(data.data)
									res.content = cont.data
									res.conversationId = data.node_execute_uuid
								}
							} catch {

							}
							res.aiid = data.id

						}
						if (data.usage) {
							res.usage.inputTokens = data.usage.input_count || 0
							res.usage.outputTokens = data.usage.output_count || 0
							res.usage.totalTokens = data.usage.token_count || 0
							// res.conversationId = data.node_execute_uuid
						}


						return res;
					},
					// 扣子智能体 coze_bot
					coze_bot: (data) => {
						const res = {
							content: "",
							follow: [],
							usage: {
								inputTokens: 0,
								outputTokens: 0,
								totalTokens: 0
							},
							conversationId: "",
							aiContent: '',
							aiid: '',
						};

						//流式建议咨询


						if (data.type === "follow_up") {
							res.follow.push(data.content)
						}
						if (data.type === "answer") {
							if (!data.created_at && data.content) {
								res.content += data.content
							}
							if (data.reasoning_content) {
								res.aiContent += data.reasoning_content
							}

						}
						//流式消耗
						if (data.status === "completed" && data.usage) {
							res.aiid = data.id
							res.usage.inputTokens = data.usage.input_count || 0;
							res.usage.outputTokens = data.usage.output_count || 0;
							res.usage.totalTokens = data.usage.token_count || 0;
							res.conversationId = data.conversation_id;
						}
						//非流式文本
						if (data && data.usag) {
							res.aiid = data.id
							res.usage.inputTokens = data.usag.input_count || 0;
							res.usage.outputTokens = data.usag.output_count || 0;
							res.usage.totalTokens = data.usag.token_count || 0;
							for (let i = 0; i < data.data.length; i++) {
								if (data.data[i].type === "answer") {
									res.aiContent = data.data[i].reasoning_content || ''
									res.content = data.data[i].content || ''
									res.conversationId = data.data[i].conversation_id || ''
								}
								if (data.data[i].type === "follow_up") {
									res.follow.push(data.data[i].content)
								}
							}
						}

						return res;
					},

					// 火山引擎 volc
					volc: (data) => {
						const res = {
							content: "",
							follow: [],
							usage: {
								inputTokens: 0,
								outputTokens: 0,
								totalTokens: 0
							},
							conversationId: "",
							aiContent: ''
						};
						//流式文本
						if (data.type === "response.output_text.delta") {
							res.content += data.delta
						}
						//流式思考过程
						if (data.type === 'response.reasoning_summary_text.delta') {
							res.aiContent += data.delta
						}
						//流式消耗
						if (data.type === "response.completed") {
							res.usage.inputTokens = data.response.usage.input_tokens || 0;
							res.usage.outputTokens = data.response.usage.output_tokens || 0;
							res.usage.totalTokens = data.response.usage.total_tokens || 0;
						}
						//非流式判断
						if (data.status === "completed" && !data.type) {
							res.aiContent = res.content = data.output[0].summary[0].text
							res.content = data.output[1].content[0].text || ''
							res.usage.inputTokens = data.usage.input_tokens || 0;
							res.usage.outputTokens = data.usage.output_tokens || 0;
							res.usage.totalTokens = data.usage.total_tokens || 0;
						}
						if (data.id) {
							res.conversationId = data.id;
						}
						return res;
					},
					deepseek: (data) => {
						const res = {
							content: "",
							follow: [],
							usage: {
								inputTokens: 0,
								outputTokens: 0,
								totalTokens: 0
							},
							conversationId: "",
							aiContent: ''
						};

						if (data && data.choices) {
							if (data.choices[0].delta) {

								if (data.choices[0].delta.content) {
									console.log('data.choices[0].delta.content', data.choices[0].delta.content)
									res.content += data.choices[0].delta.content
								}

							}
							if (data.choices[0].delta) {
								if (data.choices[0].delta.reasoning_content && data.choices[0].delta
									.reasoning_content != "null") {
									res.aiContent += data.choices[0].delta.reasoning_content
								}
							}
							if (data.choices[0].message) {
								if (data.choices[0].message.content) {
									res.content += data.choices[0].message.content
								}
								if (data.choices[0].message.reasoning_content) {
									res.aiContent += data.choices[0].message.reasoning_content
								}
							}
						}

						if (data.usage) {

							res.usage.inputTokens = data.usage.completion_tokens || 0;
							res.usage.outputTokens = data.usage.prompt_tokens || 0;
							res.usage.totalTokens = data.usage.total_tokens || 0;
						}
						return res;
					},
					dashScope: (data) => {
						const res = {
							content: "",
							follow: [],
							usage: {
								inputTokens: 0,
								outputTokens: 0,
								totalTokens: 0
							},
							conversationId: "",
							aiContent: ''
						};

						// 1. 顶层先取 output，百炼maas固定外层output
						if (!data || !data.output || !Array.isArray(data.output.choices)) return res;
						const choices = data.output.choices;
						if (choices.length === 0) return res;
						const choiceZero = choices[0];

						// 2. 提取request_id 赋值给会话ID（后端最终入库用这个）
						if (data.request_id) {
							res.conversationId = data.request_id;
						}

						// 3. 取message（百炼流式无delta，所有增量都在message里）
						if (choiceZero.message && typeof choiceZero.message === 'object') {
							const msg = choiceZero.message;
							// 拼接回答正文
							if (msg.content) {
								res.content += msg.content;
							}
							// 拼接深度思考推理内容
							if (msg.reasoning_content && msg.reasoning_content !== "null") {
								res.aiContent += msg.reasoning_content;
							}
						}

						// 4. 累加token用量
						if (data.usage && typeof data.usage === 'object') {
							res.usage.inputTokens = Number(data.usage.input_tokens || 0);
							res.usage.outputTokens = Number(data.usage.output_tokens || 0);
							res.usage.totalTokens = Number(data.usage.total_tokens || 0);
						}

						return res;
					},
				};


				const currentParser = parseRules[platform] || parseRules.local;

				try {

					this.chatList.push({
						role: "ai",
						messageList: [{
							"content": '',
							"fileType": "text"
						}],
						time: Date.now()
					});
					const aiMsgIndex = this.chatList.length - 1;
					this.scrollBottom();
					let aiid = ''
					let tokenInfo = {
						inputTokens: 0,
						outputTokens: 0,
						totalTokens: 0
					};
					let aiContent = ''
					let conversationId = null;
					let followUpList = [];
					const token = localStorage.getItem('token');

					const res = await fetch(url, {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							Authorization: token || ""
						},
						body: JSON.stringify({
							content: messageList,
							// messageList:messageList,
							modelId: this.chatArr.modelId,
							keyId: this.chatArr.keyId,
							courseClassId: this.courseClassId,
							studentId: this.studentId,
						})
					});

					if (!res.ok) {
						console.error("接口请求异常", res.status);
						return null;
					}

					const reader = res.body.getReader();
					const decoder = new TextDecoder();
					let buffer = "";

					while (true) {
						const {
							done,
							value
						} = await reader.read();
						if (done) break;

						buffer += decoder.decode(value, {
							stream: true
						});
						const lines = buffer.split(/\r?\n/);
						buffer = lines.pop() || "";

						for (const line of lines) {
							const trimLine = line.trim();
							if (!trimLine || !trimLine.startsWith("data:")) continue;

							const jsonStr = trimLine.replace("data:", "").trim();
							if (jsonStr === "[DONE]" || jsonStr === '"[DONE]"') continue;

							try {
								let data = jsonStr
								if (typeof jsonStr === 'string') {
									try {
										data = JSON.parse(jsonStr);
									} catch (e) {
										continue;

									}
								}
								if (platform == "coze_bot" && data.code && data.code != 0) {
									console.log(data.msg)
									this.$message(data.error)
									continue
								}
								const parseResult = currentParser(data);

								// ============================
								// 🔥 实时输出（完全沿用你原来的写法）
								// ============================
								if (parseResult.content) {
									this.chatList[aiMsgIndex].messageList[0].content += parseResult.content;
									
									this.scrollBottom();
								}
								if (parseResult.aiContent) {
									aiContent += parseResult.aiContent;

								}

								// 追问
								if (parseResult.follow.length) {
									followUpList.push(...parseResult.follow);
								}

								// token
								if (parseResult.usage) {
									aiid = parseResult.aiid || ''
									tokenInfo.inputTokens = parseResult.usage.input_count || parseResult.usage
										.inputTokens || 0;
									tokenInfo.outputTokens = parseResult.usage.output_count || parseResult.usage
										.outputTokens || 0;
									tokenInfo.totalTokens = parseResult.usage.token_count || parseResult.usage
										.totalTokens || 0;
								}

								// 会话ID
								if (parseResult.conversationId && !conversationId) {
									conversationId = parseResult.conversationId;
									this.saveConversationId(conversationId);
								}

							} catch (e) {
								// console.warn("解析失败", e);
								continue;
							}
						}
					}

					// 结束后赋值
					this.$set(this.chatList[aiMsgIndex], 'tokenInfo', tokenInfo);
					this.followUpList = followUpList;
					if (this.followUpList.length > 0) {
						this.scrollBottom();
					}
					localStorage.setItem('followUpList', JSON.stringify(followUpList));

					return {
						fullContent: this.chatList[aiMsgIndex].messageList[0].content,
						inputTokens: tokenInfo.inputTokens,
						outputTokens: tokenInfo.outputTokens,
						followUpList,
						aiContent,
						aiid: aiid,
					};

				} catch (err) {
					console.error("AI调用异常", err);
					return null;
				} finally {
					this.isAIApiProcessing = false;
				}
			},
			async saveConversationId(conversationId) {
				if (this.hasSavedConversationId) return;
				try {
					await this.API.post(this.API.school.saveConversationId, {
						courseClassId: this.courseClassId,
						studentId: this.studentId,
						conversationId: conversationId
					});
					this.hasSavedConversationId = true;
				} catch (e) {}
			},

			// 上报聊天
			async forPostStudentChat(messageList, role, requestToken, consumeToken, aiContent, followUpList, aiid) {
				try {
					await this.API.post(this.API.school.postChat, {
						schoolId: Number(this.schoolId),
						courseClassId: this.courseClassId,
						studentId: Number(this.studentId),
						studentName: this.studentName,
						messageList: messageList,
						requestToken: requestToken || 0, //请求
						consumeToken: consumeToken || 0, //返回
						role: role,
						aiContent: aiContent || '',
						followUpList: followUpList || '',
						modelId: this.chatArr.modelId,
						keyId: this.chatArr.keyId,
						aiid: aiid || '',
						source: 1
					})
					return true
				} catch (e) {
					return false
				}
			}
		}
	};
</script>

<style scoped>
	.chat-wrapper {
		height: calc(100vh - 280px);
		display: flex;
		flex-direction: column;

		overflow: hidden;
	}

	.header-bar {
		background-color: #c5e1a5;
		color: #8b5a2b;
		padding: 0;
		text-align: center;
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.title-text {
		font-size: 26px;
		font-weight: bold;
	}

	.chat-container {
		height: calc(100vh - 250px);
		flex: 1;
		padding: 0 16px;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
	}

	.top-icons {
		padding: 10px 0;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 30px;
	}

	.icon {
		width: 60px;
		height: 60px;
		font-size: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		animation: scaleBounce 2s infinite ease-in-out;
	}

	.icon img {
		width: 60px;
		height: 60px;
	}

	@keyframes scaleBounce {

		0%,
		100% {
			transform: scale(1);
		}

		50% {
			transform: scale(1.2);
		}
	}

	/* 消息布局 */
	.msg-item {
		display: flex;
		margin: 12px 0;
		max-width: 80%;
		display: flex;
		margin: 12px 0;
		max-width: 80%;
		height: auto;
		/* 内容自适应高度 */
		align-self: flex-start;
		/* 关键！不让消息撑满容器 */
	}

	.msg-item.left {
		flex-direction: row;
		margin-right: auto;
	}

	.msg-item.right {
		flex-direction: row-reverse;
		margin-left: auto;
	}

	.avatar {

		font-size: 24px;
		margin: 0 8px;
		flex-shrink: 0;
	}

	.avatar img {
		width: 34px;
	}

	.msg-content {
		background: #fff;
		padding: 12px 16px;
		border-radius: 16px;
		line-height: 1.6;
	}

	.msg-item.right .msg-content {
		background: #c5e1a5;
		color: #333;
	}

	.msg-time {
		font-size: 12px;
		color: #999;
		margin-bottom: 4px;
	}

	/* 输入框 */
	.input-bar {
		background-color: #fff9e6;
		padding-left: 10px;
		padding-right: 20px;
		display: flex;
		align-items: center;
		gap: 10px;
		flex-shrink: 0;
		height: 70px;
	}

	.chat-input {
		flex: 1;
		min-width: 0;
		border: 2px solid #c5e1a5;
		border-radius: 24px;
		padding: 10px 16px;
		font-size: 17px;
		outline: none;
		background-color: #fff;
	}

	.send-btn {
		background-color: #81c784;
		color: white;
		border: none;
		border-radius: 20px;
		padding: 8px 14px;
		font-size: 15px;
		cursor: pointer;
		flex-shrink: 0;
	}

	.send-btn:disabled {
		opacity: 0.6;
	}

	.mic-btn {
		width: 48px;
		height: 48px;
		border-radius: 50%;
		background-color: #81c784;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		flex-shrink: 0;
	}

	.follow-up-item {
		/* 核心：根据内容自动宽度 */
		width: fit-content;
		/* 最大不超过 75% */
		max-width: 70%;

		padding: 6px 14px;
		margin-top: 5px;
		/* 左边距保留你的 10% */
		margin-left: 50px;
		background-color: #f5f7f9;
		border: 1px solid #e8e9eb;
		border-radius: 18px;
		font-size: 14px;
		color: #333;
		cursor: pointer;
		transition: all 0.2s;
		/* 防止文字撑破容器，自动换行 */
		word-wrap: break-word;
		white-space: pre-wrap;
	}

	.follow-up-item:hover {

		background-color: #e9edf1;
		border-color: #dcdfe6;
	}

	.chat-img {
		max-width: 100%;
		height: auto;
	}

	/* 图片预览区域，上浮在输入框上方 */
	.input-wrapper {
		position: relative;
		margin-top: 10px;
	}

	.upload-preview-box {
		position: absolute;
		bottom: 100%;
		left: 0;
		right: 0;
		margin-bottom: 8px;
		display: flex;
		gap: 8px;
		padding: 8px 12px;
		background: #f7f8fa;
		border-radius: 8px;
		flex-wrap: wrap;
		z-index: 10;
	}

	.preview-item {
		position: relative;
		width: 80px;
		height: 80px;
		border-radius: 4px;
		overflow: hidden;
		border: 1px solid #e5e7eb;
	}

	.preview-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.close-del {
		position: absolute;
		top: 2px;
		right: 2px;
		width: 18px;
		height: 18px;
		background: rgba(0, 0, 0, 0.6);
		color: #fff;
		text-align: center;
		line-height: 18px;
		border-radius: 50%;
		font-size: 14px;
		cursor: pointer;
	}

	.input-bar {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 10px 12px;
		border: 1px solid #e5e7eb;
		border-radius: 8px;
	}

	.upload-img-btn {
		font-size: 20px;
		cursor: pointer;
		user-select: none;
	}

	.chat-input {
		flex: 1;
		padding: 8px 12px;
		border: 1px solid #ddd;
		border-radius: 4px;
		outline: none;
	}

	.send-btn {
		padding: 6px 16px;
		background: #409eff;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
	}

	.send-btn:disabled {
		background: #a0cfff;
		cursor: not-allowed;
	}
</style>